import { render, staticRenderFns } from "./SearchBarNew.vue?vue&type=template&id=04a17958&"
import script from "./SearchBarNew.vue?vue&type=script&lang=js&"
export * from "./SearchBarNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports